/**
 * Extracts UTM parameters from the provided window's location search string.
 * This function is intended to be run on the client side only.
 *
 * @returns {Record<string, string>} A key-value map of UTM parameters.
 */
export const getUTMParams = (): Record<string, string | boolean> => {
  const utmParams: Record<string, string | boolean> = {}

  // If this function is called from the server
  // Log a warning and return the empty utmParams object
  if (typeof window === 'undefined') {
    console.warn('getUTMParams should only be called from the client-side.')
    return utmParams
  }

  const queryParams = new URLSearchParams(window.location.search)

  // If there are no query params, return the empty utmParams object
  if (queryParams.toString() === '') {
    return utmParams
  }

  // Iterate over the query params
  for (const [key, value] of queryParams.entries()) {
    if (key.startsWith('utm_')) {
      utmParams[key] = value
    } else if (key === 'n') {
      // If the 'n' param is present, it means the user clicked on a sms notification
      // We simply send the URL with /?n in sms notifications to keep the url short
      // e.g. https://my.rosebud.app/?n
      // e.g. https://my.rosebud.app/compose/prompt-123/?n
      utmParams['utm_source'] = 'notification'
      utmParams['utm_medium'] = 'sms'
    }
  }

  return utmParams
}
